import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('PaymentEvent', PaymentEventData);

    PaymentEventData.$inject = ['UtilSvc'];

    /* @ngInject */
    function PaymentEventData(UtilSvc) {
        PaymentEvent.prototype = {
            build: build,
        };

        function PaymentEvent(paymentEventData) {
            if (paymentEventData) {
                this.build(paymentEventData);
            }
        }

        return PaymentEvent;

        function build(paymentEventData) {
            this.status = paymentEventData.status || null;
            this.createdDate = UtilSvc.parseDate(paymentEventData.createdDate) || null;
            this.paidAmount = paymentEventData.paidAmount || null;
            this.content = angular.fromJson(paymentEventData.eventJson) || null;
        }
    }
})();
